// Module
var code = "<span class=\"quote__open quote__open--desktop sofia extra-bold\"> “ </span> <p> <span class=\"quote__open quote__open--mobile sofia extra-bold\">“</span> <span class=\"quote__text sofia regular\"> </span>&nbsp;<span class=\"quote__close sofia extra-bold\">„</span> </p> ";
// Exports
export default code;